import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  viewBox: "190.95 195.96 20.9 20.37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M211.47 199.205C210.147 198.776 209.102 197.733 208.674 196.412C208.528 195.959 207.774 195.959 207.628 196.412C207.2 197.733 206.155 198.776 204.832 199.205C204.605 199.279 204.451 199.49 204.451 199.729C204.451 199.966 204.605 200.177 204.832 200.251C206.153 200.679 207.198 201.727 207.628 203.055C207.7 203.282 207.913 203.436 208.15 203.436C208.389 203.436 208.601 203.282 208.674 203.055C209.104 201.727 210.149 200.679 211.47 200.251C211.697 200.177 211.851 199.966 211.851 199.729C211.851 199.49 211.697 199.279 211.47 199.205Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M207.531 206.64L202.325 204.95L200.635 199.744C200.49 199.293 200.087 199.002 199.612 199.002C199.136 199.002 198.734 199.293 198.588 199.744L196.913 204.946L191.697 206.639C191.25 206.781 190.95 207.193 190.95 207.665C190.95 208.135 191.25 208.547 191.694 208.688L196.896 210.369L198.588 215.583C198.734 216.034 199.136 216.327 199.612 216.327C200.087 216.327 200.49 216.034 200.635 215.583L202.313 210.382L207.528 208.689C207.974 208.547 208.276 208.135 208.276 207.665C208.276 207.193 207.974 206.781 207.531 206.64Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }